import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../RenderStyle.css";

import EC_Render from "../../../../../UiComponents/EC_Render";
import Navbar from '../../../../../UiComponents/June2026/Navbar';
import RenderNavbar from '../../../../../UiComponents/June2026/RenderNavbar';
import RenderSettings from '../../RenderSettings';
import RendersTable from '../RendersTable';
import { Scrollx_animate } from "../../../../../assets/icons";

import { renderSettingsOptions, fpsNumAndDen, commonFps, format } from "../../render.constants";
import html2canvas from "html2canvas";
import dataURItoBlob from "../../../../../services/dataToBlob";
import { setCurrentNotification } from "../../../../utils/global";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { increaseRenderCnt } from "../../../../../Redux/actions/authActions";
import { updatePreviewScale } from "../../../../../Redux/actions/applicationActions";
import { requestRenderXVideo, deleteRenders, deleteAllRenders, downloadRender } from "../../../../../Redux/actions/projectActions";
import ConfirmationModal from "../../../../../Components/ConfirmationModal/ConfirmationModal";
import { getCurrentPlan, getRendersPlan, getNotification, addNotifications, getUserAllInformation, markRenderDone } from "../../../../../Redux/actions/commonActtion";

import { toast } from "react-toastify";
import CustomToast, { customToatStyle } from "../../../../../Components/CustomToast/CustomToast";

import { generateBlockImages } from "../../../../utils/generateCreditsPng";

const freeRenderFormats = Object.entries(format).map(([key, value]) => ({ label: key, value: value }));
const freeFramRate = commonFps.map((fps) => ({ label: fps, value: 23.976 }));
const freeRenderSettingsOptions = Object.keys(renderSettingsOptions).map(
  (resolutionType) => {
    return { label: resolutionType, value: resolutionType };
  },
);
const defaultResolution = "1280 x 720";
const mesg = "Rendering in Progress Your render is currently being processed. You will receive a notification via email when its complete. Thank you for your patience!";

const ScrollRender = ({ renderOpen, setRenderOpen, currentBlockIdx, isRenderExport, setIsRenderExport }) => {
  console.log("1 ScrollRender Component Mounted Props => ", { renderOpen, setRenderOpen, currentBlockIdx, isRenderExport, setIsRenderExport });
  const user = JSON.parse(localStorage.getItem("user"));
  const { projectId } = useParams();

  const navigate = useNavigate();  
  const dispatch = useDispatch();

  const [aspectRatio, setAspectRatio] = useState("1.78");
  const [isEmailSend, setIsEmailSend] = useState(true);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpgradeOpen, IsUpgradeOpen] = useState(false);
  const [isPlanShow, setIsPlanShow] = useState(false);

  const { isCard, _id } = useSelector((state) => state?.project);
  let { isLoading, renders } = useSelector((state) => state?.project);
  const { renderPlan, subscriptionStatus } = useSelector((state) => state.commonReducer);
  const commonReducer = useSelector((state) => state?.commonReducer);

  const { userData, renderDone, currentPlan } = useSelector((state) => state?.commonReducer);
  const iscurrentPlanActivate = Object.keys(currentPlan).length === 0;
  const currentPlanDetails = currentPlan?.plan?.plan_detail;
  const [isUserPaid, setIsUserPaid] = useState(currentPlan.isExpired ? false : true);
  

  useEffect(() => {
    setIsUserPaid(currentPlan.isExpired ? false : true);
  }, [currentPlan.isExpired]);

  // if user is paid, we are getting the settings from local storage, if user is not paid, we are removing the settings from local storage
  let renderSettingData = null;
  if (isUserPaid) {
    renderSettingData = JSON.parse(localStorage.getItem("renderSettings"));
  } else if (!isUserPaid) {
    if (renderSettingData) {
      localStorage.removeItem("renderSettings");
    }
  }
  // const renderSettingFormat = renderSettingData !== null ? renderSettingData.format !== "H264" ? renderSettingData.format.substring(6) : "H264" : "";

  const renderSettingFormat = renderSettingData !== null ? renderSettingData.format : ""; 

  // Getting default settings from local storage, if renderSettings is available otherwise we are taking default setting
  const [resolution, setResolution] = useState(
    renderSettingData !== null ? renderSettingData.resolution : defaultResolution,
  );
  const [formats, setFormats] = useState(
    renderSettingData !== null ? renderSettingFormat : "H264",
  );
  const [fps, setFps] = useState(
    renderSettingData !== null
      ? renderSettingData.fps
      : renderSettingsOptions[defaultResolution].fps[0],
  );
  const [sppf, setSpps] = useState(
    renderSettingData !== null ? renderSettingData.sppf : 5,
  );

  const resolutionKeys = Object.keys(renderSettingsOptions);
  const resolutionIndex = resolutionKeys.indexOf(resolution);

  const createdAt = new Date(currentPlan?.plan?.createdAt);
  const planPurchaseDate = isNaN(createdAt.valueOf())
    ? ""
    : `${createdAt?.getDate()}/${createdAt?.getMonth() + 1
    }/${createdAt?.getFullYear()}`;

  const validityValue = parseInt(currentPlanDetails?.validity, 10) || 0;
  const [remainingDays, setRemainingDays] = useState("");
  const [remainingHours, setRemainingHours] = useState(0);
  const [remainingMinutes, setRemainingMinutes] = useState(0);
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  const [unsubscribeState, setUnsubscribeState] = useState(false);
  const [buyBackActive, setBuyBackActive] = useState();

  const [min, setMin] = useState(0);
  const [sec, setSec] = useState(0);

  const today = new Date();
  const planRenewDate = new Date(
    createdAt?.getTime() + validityValue * 24 * 60 * 60 * 1000,
  );
  let timeDifference = planRenewDate - today;

  useEffect(() => {
    let prevRemainingDays = remainingDays;
    if (remainingDays === 1 || validityValue === 1) {
      const interval = setInterval(() => getTime(prevRemainingDays), 1000);
      return () => clearInterval(interval);
    } else {
      getTime(prevRemainingDays);
    }
    const purchaseDate = currentPlan?.plan?.createdAt;
    if (purchaseDate) {
      const purchaseTime = new Date(purchaseDate);
      const buyBackTime = new Date(
        purchaseTime.getTime() + 3 * 24 * 60 * 60 * 1000,
      );
      const isBuyBackActive = buyBackTime >= new Date();

      setBuyBackActive(isBuyBackActive);
    }

    dispatch(getUserAllInformation());
  }, []);

  useEffect(() => {
    getRenderPlanDetails();
  }, [isSuccessOpen]);
  useEffect(() => {
    const roleName_tr = document.querySelectorAll(".roleName_tr");
    const scrollable = document.querySelectorAll(".scrollable");
    const emptyLogo = document.querySelectorAll(".border-for-empty-logo");
    const bulletClas = document.querySelectorAll(".bullet");
    // const RespPreviewClass = document.querySelectorAll(".RespPreviewClass");

    function handleStatusChange() {
      if (roleName_tr) {
        roleName_tr?.forEach((tr) => {
          tr.style.display = "flex";
          tr.style.alignItems = "end";
        });
      }
      if (emptyLogo) {
        emptyLogo?.forEach((el) => {
          if (el.classList.contains("border-for-empty-logo")) {
            el.classList.replace(
              "border-for-empty-logo",
              "border-none-for-empty-logo",
            );
          }
        });
      }
      if (scrollable) {
        scrollable?.forEach((div) => {
          div.style.height = "100vh";
        });
      }
      if (bulletClas) {
        bulletClas?.forEach((span) => {
          span.style.display = "inline-block";
          span.style.backgroundColor = "tranparent";
          span.style.marginTop = "0.05em";
        });
      }
      // if (RespPreviewClass) {
      //   RespPreviewClass?.forEach((div) => {
      //     div.style.zoom = "1";
      //   });
      // }
    }

    handleStatusChange();
    return function cleanup() {
      if (roleName_tr) {
        roleName_tr?.forEach((tr) => {
          tr.style.display = "flex";
          tr.style.alignItems = "baseline";
        });
      }
      if (emptyLogo) {
        emptyLogo?.forEach((el) => {
          if (el.classList.contains("border-none-for-empty-logo")) {
            el.classList.replace(
              "border-none-for-empty-logo",
              "border-for-empty-logo",
            );
          }
        });
      }
      if (scrollable) {
        scrollable?.forEach((div) => {
          div.style.height = "100%";
        });
      }

      if (bulletClas) {
        bulletClas?.forEach((span) => {
          span.style.display = "flex";
          span.style.justifyContent = "center";
          span.style.alignItems = "center";
        });
      }
      // if (RespPreviewClass) {
      //   RespPreviewClass?.forEach((div) => {
      //     div.style.zoom = ".8";
      //   });
      // }
    };
  });

  const getTime = async (prevRemainingDays) => {
    if (!isNaN(validityValue)) {
      if (timeDifference > 0) {
        if (timeDifference >= 24 * 60 * 60 * 1000) {
          const updatedRemainingDays = Math.ceil(
            timeDifference / (24 * 60 * 60 * 1000),
          );
          timeDifference -= updatedRemainingDays * 24 * 60 * 60 * 1000;

          if (prevRemainingDays === 1 && updatedRemainingDays === 0) {
            setRemainingHours(0);
            setRemainingMinutes(0);
            setRemainingSeconds(0);
            setIsUserPaid(false);
          }
          setRemainingDays(updatedRemainingDays);
        }
        if (timeDifference >= 60 * 60 * 1000) {
          setRemainingHours(Math.floor(timeDifference / (60 * 60 * 1000)));
          timeDifference -= remainingHours * 60 * 60 * 1000;
        }

        if (timeDifference >= 60 * 1000) {
          setRemainingMinutes(Math.floor(timeDifference / (60 * 1000)));
          timeDifference -= remainingMinutes * 60 * 1000;
        }

        setRemainingSeconds(Math.floor(timeDifference / 1000));
      } else if (remainingDays === 0) {
        setIsUserPaid(false);
      } else {
        setRemainingDays(0);
        setRemainingHours(0);
        setRemainingMinutes(0);
        setRemainingSeconds(0);
      }
    }
  };
  const handleResolutionChange = (val) => {
    setResolution(val);
    if (!renderSettingsOptions[val].fps.includes(fps)) {
      setFps(renderSettingsOptions[val].fps[0]);
    }
    setAspectRatio(renderSettingsOptions[val].aspectRatio);
  };

  const handleFormatChange = (val) => {
    setFormats(val);
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const getRenderPlanDetails = async () => {
    await dispatch(getRendersPlan(user));
    await dispatch(getCurrentPlan());
  };

  // function to get render time according to the png that is being formed from our side;
  const getHeight = () => {
    const { width: videoWidth, height: videoHeight } =
      renderSettingsOptions[resolution];
    const previewScale = videoWidth / 800;
    let blocks = document.querySelectorAll(".blockWrapper");

    const scaledFontSize = 16 * previewScale;
    blocks.forEach((el) => {
      el.style.height = el.clientHeight * previewScale + "px";
      el.style.minHeight = el.clientHeight * previewScale + "px";
      el.style.fontSize = scaledFontSize + "px";
    });

    let totalHeight = 0;
    blocks.forEach((el) => {
      totalHeight += el.offsetHeight;
    });
    totalHeight = totalHeight + 2 * videoHeight;

    let time = totalHeight / (sppf * fps);
    if (videoHeight >= 2000) time -= 20;

    const min = Math.floor(time / 60);
    const sec = Math.floor(time % 60);
    setMin(min);
    setSec(sec);

    blocks.forEach((el) => {
      el.removeAttribute("style");
    });
  };

  const handleExport = async () => {
    setLoading(true);
    try {
      const { width: videoWidth, height: videoHeight } =
        renderSettingsOptions[resolution];
      const previewScale = videoWidth / 800;

      // Capture DOM references BEFORE dispatching updatePreviewScale.
      // Dispatching first can trigger a React re-render that unmounts #preview,
      // causing a silent TypeError that swallows the entire render request.
      const blocks = document.querySelectorAll(".blockWrapper");
      const scaledFontSize = 16 * previewScale;

      // Block heights are measured AFTER dispatch(updatePreviewScale) below.
      // The editor previews at ~1600px (previewBaseWidth) but EXPORTS at 800px
      // logical width scaled up, and the bullet block (flex-wrap) wraps very
      // differently at 800px. Measuring here — at the preview width — reserved
      // too little height, which cut off the last line(s) of the bullet block.

      const scrollPixelPerFrame = sppf;
      const { num: fpsNumerator, den: fpsDenominator } = fpsNumAndDen[fps];

      const focusedNode = document.getElementById("view_" + currentBlockIdx);
      focusedNode?.classList?.remove("focusDiv");
      const element = document.getElementById("preview");

      // Guard: if #preview is missing (e.g. due to an earlier re-render), abort with a visible error.
      if (!element) {
        throw new Error("Preview element not found. Please close and reopen the Render panel and try again.");
      }

      element.classList.remove("scrollable");

      element.setAttribute(
        "style",
        `width: ${videoWidth}px;height:100%;background-color: transparent;`,
      );

      // Now safe to dispatch — DOM references are already captured above.
      dispatch(updatePreviewScale(previewScale));

      // The dispatch reflows every block to the 800px export width (and lets the
      // bullet ResizeObserver re-hide line-end bullets for THAT width). Wait for
      // the reflow, then measure each block's real content height and reserve it
      // (× previewScale for the CSS transform scale). This stays content-based —
      // it is NOT a fixed frame — it just measures at the width the block is
      // actually rendered at, so the last line is never cut off.
      await sleep(300);

      const originalHeights = Array.from(blocks).map((el) => el.clientHeight);
      blocks.forEach((el, i) => {
        el.style.height = originalHeights[i] * previewScale + "px";
        el.style.minHeight = originalHeights[i] * previewScale + "px";
        el.style.fontSize = scaledFontSize + "px";
      });

      if (!isUserPaid) {
        const elementsToHide = document.querySelectorAll(
          ".blockWrapper .watermark_displaynone",
        );
        elementsToHide?.forEach((el) => {
          el?.classList?.replace("watermark_displaynone", "watermark");
        });
      }

      await sleep(1000);

      const images = await generateBlockImages({
        onProgress: (done, total) => {
          console.log(`Captured block ${done}/${total}`);
        },
      });

      localStorage.setItem(
        "renderSettings",
        JSON.stringify({
          resolution,
          format: formats,
          sppf: scrollPixelPerFrame,
          fps,
        }),
      );

      console.log("3 Image generation complete => ");

      const renderResult = await dispatch(
        requestRenderXVideo(images, {
          videoHeight,
          videoWidth,
          scrollPixelPerFrame,
          fpsDenominator,
          fpsNumerator,
          format: formats === "H264" ? "outputH264" : formats,
          aspectRatio,
          isEmailSend,
        }),
      );
      console.log("6 Scroll Redux Response => ", renderResult);

      element.removeAttribute("style");
      focusedNode?.classList?.add("focusDiv");
      element?.classList?.add("scrollable");

      blocks.forEach((el) => {
        el.style.height = "";
        el.style.minHeight = "";
        el.style.fontSize = "";
      });

      dispatch(updatePreviewScale(1));
      dispatch(increaseRenderCnt());
      setRenderOpen(false);
      setIsRenderExport(true);

      if (renderResult?.success) {
        toast(<CustomToast title="" content={mesg} />, customToatStyle);
        const newRender = renderResult.renders;
        const renderId = newRender[newRender.length - 1]._id;

        const notifyObj = {
          name: "render",
          details: newRender[newRender.length - 1],
          project_id: _id,
          render_id: renderId,
          message: `Rendering Completed ${newRender[newRender.length - 1].videoFilename}`,
          status: 1,
          user_id: user._id,
        };
        setCurrentNotification(notifyObj);

        await dispatch(
          addNotifications({
            project_id: _id,
            render_id: renderId,
            message: `Render in progress ${newRender[newRender.length - 1].videoFilename}`,
            status: 1,
            user_id: user._id,
          }),
        );

        dispatch(increaseRenderCnt());
        setTimeout(() => window.location.reload(), 100);
      } else {
        toast(<CustomToast title="" content={"Failed"} />, customToatStyle);
      }
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };


  const handleExportSubmit = () => {
    console.log("1 Scroll Render Start handleExportSubmit Verify User Paid or Not => ");
    if (!renderDone && buyBackActive) {
      dispatch(markRenderDone());
    }

    if (isUserPaid) {
      console.log("! Scroll Render Start handleExportSubmit => Paid User ", isUserPaid);
      handleExport();
    }

    if (!isUserPaid) {
      console.log("! Scroll Render Start handleExportSubmit => Not Paid User");
      navigate("/user-plans", {
        state: {
          isRender: true,
          isMoreInfo: false,
          isCard: isCard,
          projectId: projectId ?? null,
        },
      });
      return;
    }
  };

  renders = renders?.sort(
    (a, b) => new Date(b?.createdAt) - new Date(a?.createdAt),
  );

  const paideRenderSettingsOptions = Object.keys(renderSettingsOptions).map(
    (resolutionType) => {
      return { label: resolutionType, value: resolutionType };
    },
  );
  const paideRenderFormats = Object.entries(format).map(([key, value]) => ({
    label: key,
    value: value,
  }));
  const paidFramRate = renderSettingsOptions[resolution]?.fps?.map((_fps) => ({
    label: _fps,
    value: _fps,
  }));
  const expirationMessage =
    Object.keys(currentPlan).length === 0
      ? "With scrollx watermark"
      : remainingDays === 0
        ? "Plan Expired"
        : remainingDays === 1 || validityValue === 1
          ? `Plan Expires in ${remainingHours}:${remainingMinutes}:${remainingSeconds}`
          : remainingDays > 1
            ? `Remaining ${remainingDays} days`
            : "";

  function addIntervalToPurchaseDate(
    planPurchaseDate,
    interval_count,
    interval_type,
  ) {
    const purchaseDate = planPurchaseDate; // Convert purchase date to Date object

    // Check if the purchase date is valid
    if (isNaN(purchaseDate)) {
      return null;
    }

    // Based on the interval_type, add to the date accordingly
    switch (interval_type) {
      case "day":
        purchaseDate.setDate(purchaseDate.getDate() + interval_count);
        break;
      case "month":
        purchaseDate.setMonth(purchaseDate.getMonth() + interval_count);
        break;
      case "year":
        purchaseDate.setFullYear(purchaseDate.getFullYear() + interval_count);
        break;
      default:
        throw new Error("Invalid interval type");
    }

    // Return date in YYYY-MM-DD format
    return purchaseDate;
  }

  const expirationDate =
    currentPlanDetails !== null
      ? addIntervalToPurchaseDate(
        createdAt,
        currentPlanDetails?.interval_count,
        currentPlanDetails?.interval,
      )
      : new Date();

  const expiryString =
    currentPlanDetails !== null && expirationDate !== null
      ? `Expiration Date ${expirationDate.getDate()}/${expirationDate.getMonth() + 1
      }/${expirationDate.getFullYear()}`
      : "";

  const renewalString =
    currentPlanDetails !== null && expirationDate !== null
      ? `Renewal Date ${expirationDate.getDate()}/${expirationDate.getMonth() + 1
      }/${expirationDate.getFullYear()}`
      : "";

  const currentDate = new Date();
  const isPlanActive = currentDate < expirationDate;

  useEffect(() => {
    getHeight();
  }, [sppf, fps, resolution]);

  return (
    <>
      <EC_Render isOpen={renderOpen} closeModal={() => setRenderOpen(false)}>
      {loading ? (
        <div className="requestLoader">
          <img className="absolute opacity-80" width="120px" height="120px" src={Scrollx_animate} />
          <p className="mt-[8rem] text-[0.9rem] text-white">Requesting Video ... </p>
        </div>
      ) : null}

      {/* <ConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleConfirm}
        message="By clicking 'Render', you agree that the 3-day money-back guarantee will be void. Are you sure you want to continue?"
      /> */}

      <div className="bodyContainer" style={{ minHeight: "100vh", minHeight: "-webkit-fill-available" }}>

        <div className="particles"></div>

        <div className="layoutContainer-shell">

          <header className='header-topbar' >
            <RenderNavbar closeModal={() => setRenderOpen(false)} />
          </header>

          {/* zoom scaling applies to page content only, so the navbar stays a fixed height */}
          <main className="renderPage-Container responsiveZoomClass w-full max-w-[1388px] mx-auto px-4 md:px-8 py-8 md:py-10">

            <section className="mx-auto topSection">
              <div className=" renderSection1">
                <RenderSettings 
                  renderOpen={renderOpen} 
                  IsUpgradeOpen={IsUpgradeOpen}

                  isCard={isCard}
                  
                  resolution={resolution}
                  handleResolutionChange={handleResolutionChange}
                  resolutionIndex={resolutionIndex}
                   
                  freeRenderSettingsOptions={freeRenderSettingsOptions}

                  freeRenderFormats={freeRenderFormats} 
                  formats={formats}
                  handleFormatChange={handleFormatChange}

                   
                  freeFramRate={freeFramRate}
                  paidFramRate={paidFramRate}

                  fps={fps} 
                  setFps={setFps}

                  sppf={sppf} 
                  setSpps={setSpps}

                  min={min} 
                  sec={sec}
                  
                  isEmailSend={isEmailSend} 
                  setIsEmailSend={setIsEmailSend}
                  
                  handleScrollRenderExport={handleExportSubmit} 
                  isLoading={isLoading}
                  loading={loading}

                  renderCnt={3}
                  
                  isUserPaid={isUserPaid}
                  isPlanActive={isPlanActive} 
                  
                  paideRenderSettingsOptions={paideRenderSettingsOptions}

                  paideRenderFormats={paideRenderFormats}                 

                />
              </div>
            </section>

            <section className='mx-auto bottomSection'>
              <div className=" renderSection2">
                <RendersTable />
              </div>
            </section>

          </main>

        </div>
      </div>
</EC_Render>

    </>
  )
}

export default ScrollRender;